var _defs, _circle, _circle2, _circle3, _circle4, _path, _path2, _g, _g2, _g3, _ellipse, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricePointInsightsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "w-5 h-5",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFD700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF8C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "arrowUpGradient",
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00C853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#69F0AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "arrowDownGradient",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E32934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF6B75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "circleGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0055A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00A3E0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glowRadial",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFD700",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFD700",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "priceShadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 3,
    stdDeviation: 3,
    floodOpacity: 0.4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "priceGlow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "url(#glowRadial)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 20,
    fill: "url(#coinGradient)",
    filter: "url(#priceShadow)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 20,
    fill: "none",
    stroke: "#FFA500",
    strokeWidth: 2,
    opacity: 0.3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 17,
    fill: "none",
    stroke: "white",
    strokeWidth: 1.5,
    opacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 32 20 L 32 44",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    filter: "url(#priceGlow)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 26 24 C 26 24 26 22 32 22 C 38 22 38 26 34 28 C 30 30 30 30 30 30 C 30 30 30 34 34 34 C 38 34 38 36 34 38 C 30 38 28 38 28 38",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    filter: "url(#priceGlow)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12 18 L 12 8",
    stroke: "url(#arrowUpGradient)",
    strokeWidth: 3,
    strokeLinecap: "round",
    filter: "url(#priceGlow)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8 12 L 12 8 L 16 12",
    stroke: "url(#arrowUpGradient)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    filter: "url(#priceGlow)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 2,
    fill: "#69F0AE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 52 46 L 52 56",
    stroke: "url(#arrowDownGradient)",
    strokeWidth: 3,
    strokeLinecap: "round",
    filter: "url(#priceGlow)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48 52 L 52 56 L 56 52",
    stroke: "url(#arrowDownGradient)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    filter: "url(#priceGlow)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 56,
    r: 2,
    fill: "#FF6B75"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 48 12 L 56 12 L 56 20 L 52 24 L 44 16 Z",
    fill: "url(#circleGradient)",
    filter: "url(#priceShadow)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 16,
    r: 1.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 44 16 L 52 24",
    stroke: "url(#circleGradient)",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26,
    cy: 24,
    rx: 6,
    ry: 4,
    fill: "white",
    opacity: 0.3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 32,
    r: 1.5,
    fill: "white",
    opacity: 0.8
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 32,
    r: 1.5,
    fill: "white",
    opacity: 0.8
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 12,
    r: 1,
    fill: "white",
    opacity: 0.7
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 52,
    r: 1,
    fill: "white",
    opacity: 0.7
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 32,
    r: 2,
    fill: "#FFD700",
    opacity: 0.6
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 32,
    r: 2,
    fill: "#FFD700",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricePointInsightsIcon);
export default __webpack_public_path__ + "static/media/price-point-insights-icon.bde6876d7d4129be8694c19435874aa4.svg";
export { ForwardRef as ReactComponent };